import { SecretContract } from '././secret';
import { ScopeContract } from '././scope';

export interface ApplicationContract {
    id: string;
    name: string;
    environment: EnvironmentMode;
    applicationId: string;
    createdAt: string;
    secrets: SecretContract[];
    scopes: ScopeContract[];
}

export enum EnvironmentMode {
    sandbox = 'SANDBOX',
    production = 'PRODUCTION'
}
